import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSadRating = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 49,
	viewBox: "0 0 48 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24 48.0031C37.2558 48.0031 48 37.2589 48 24.0031C48 10.7473 37.2558 0 24 0C10.7442 0 0 10.7442 0 24C0 37.2558 10.7442 48 24 48",
			fill: "#ED1414"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2713 22.3991C14.2713 25.0396 12.1307 27.1771 9.49333 27.1771C6.856 27.1771 4.71533 25.0364 4.71533 22.3991C4.71533 19.7618 6.856 17.6211 9.49333 17.6211C12.1307 17.6211 14.2713 19.7618 14.2713 22.3991Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.3483 20.5477C9.3483 21.3241 8.71962 21.9528 7.94319 21.9528C7.16677 21.9528 6.53809 21.3241 6.53809 20.5477C6.53809 19.7713 7.16677 19.1426 7.94319 19.1426C8.71962 19.1426 9.3483 19.7713 9.3483 20.5477Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8921 22.7649C10.8921 23.2113 10.5306 23.5727 10.0842 23.5727C9.63786 23.5727 9.27637 23.2113 9.27637 22.7649C9.27637 22.3185 9.63786 21.957 10.0842 21.957C10.5306 21.957 10.8921 22.3185 10.8921 22.7649Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2913 22.3991C43.2913 25.0396 41.1507 27.1771 38.5133 27.1771C35.876 27.1771 33.7354 25.0364 33.7354 22.3991C33.7354 19.7618 35.876 17.6211 38.5133 17.6211C41.1507 17.6211 43.2913 19.7618 43.2913 22.3991Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3717 20.5477C38.3717 21.3241 37.7431 21.9528 36.9666 21.9528C36.1902 21.9528 35.5615 21.3241 35.5615 20.5477C35.5615 19.7713 36.1902 19.1426 36.9666 19.1426C37.7431 19.1426 38.3717 19.7713 38.3717 20.5477Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9121 22.7649C39.9121 23.2113 39.5506 23.5727 39.1042 23.5727C38.6579 23.5727 38.2964 23.2113 38.2964 22.7649C38.2964 22.3185 38.6579 21.957 39.1042 21.957C39.5506 21.957 39.9121 22.3185 39.9121 22.7649Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9225 31.2514C12.9225 32.5936 11.4577 33.6844 9.65023 33.6844C7.84276 33.6844 6.37793 32.5967 6.37793 31.2514C6.37793 29.906 7.84276 28.8184 9.65023 28.8184C11.4577 28.8184 12.9225 29.906 12.9225 31.2514Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6252 31.2514C41.6252 32.5936 40.1603 33.6844 38.3529 33.6844C36.5454 33.6844 35.0806 32.5967 35.0806 31.2514C35.0806 29.906 36.5454 28.8184 38.3529 28.8184C40.1603 28.8184 41.6252 29.906 41.6252 31.2514Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.15529 17.782C8.00637 16.6252 10.8543 15.4684 13.7054 14.3085C14.0826 14.1545 14.3435 13.8181 14.2272 13.3906C14.1297 13.0323 13.6865 12.7179 13.3093 12.8688C10.4582 14.0256 7.6103 15.1855 4.75922 16.3423C4.38201 16.4963 4.1211 16.8327 4.23741 17.2602C4.33486 17.6185 4.77808 17.9329 5.15529 17.782Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2442 16.3454C40.3932 15.1886 37.5452 14.0318 34.6973 12.8719C34.3201 12.7179 33.88 13.0354 33.7794 13.3937C33.6631 13.8212 33.924 14.1575 34.3012 14.3116L42.8482 17.7851C43.2254 17.9391 43.6655 17.6216 43.766 17.2632C43.8823 16.8357 43.6214 16.4994 43.2442 16.3454Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0117 31.352C25.9928 32.4993 25.2384 33.653 24.003 33.6781C22.7708 33.7033 22.0132 32.4585 21.9944 31.352C21.9755 30.2046 22.7959 29.051 24.003 29.0259C25.2352 29.0007 25.9928 30.2455 26.0117 31.352C26.0274 32.3107 27.5173 32.3139 27.5016 31.352C27.4702 29.3811 26.0619 27.5767 24.003 27.5359C21.9441 27.4919 20.5358 29.4502 20.5044 31.352C20.473 33.3229 21.9944 35.1272 24.003 35.1681C26.0619 35.2121 27.4702 33.2569 27.5016 31.352C27.5173 30.3901 26.0274 30.3933 26.0117 31.352Z",
			fill: "#1C1C1C"
		})
	]
});
export default SvgSadRating;
